import { SagaIterator } from 'redux-saga';
import { call, select, takeEvery } from 'redux-saga/effects';

import { localAccountIdSelector } from '../../core/auth/authentication.selectors';
import { impersonatedUserIdSelector, isSuperUserSelector } from '../Customer/customer.selectors';
import { createEvent } from './analytics.api';
import { LOG_ANALYTICS_EVENT } from './analytics.actions.constants';
import { ILogAnalyticsEventAction } from './analytics.actions.interfaces';

function* handleLogAnalyticsEvent(action: ILogAnalyticsEventAction): SagaIterator {
  const { sessionId, eventTypeId } = action.meta;
  try {
    const customerAzureUserId: string | undefined = yield select(localAccountIdSelector);
    const isSuperUser: boolean = yield select(isSuperUserSelector);
    const impersonatedUserId: string | undefined = yield select(impersonatedUserIdSelector);

    yield call(createEvent, {
      sessionId,
      eventTypeId,
      customerAzureUserId: customerAzureUserId ?? null,
      internalCompanyAzureUserId: isSuperUser ? impersonatedUserId ?? null : null,
      eventDate: new Date().toISOString()
    });
  } catch (e) {
    // swallow errors for analytics
  }
}

export default function* analyticsSaga(): SagaIterator {
  yield takeEvery(LOG_ANALYTICS_EVENT, handleLogAnalyticsEvent);
}
